<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-if="filters || typeFilter === 'subtheme' || typeFilter === 'detail'" class="options-block" :class="enabled ? '' : 'option-disabled'">
    <div class="options-block-title">{{ title }}</div>
    <div class="filter-wrapper" :class="activeFilter === typeFilter ? 'open-filter' : ''" @click="enabled && toggleFilter(typeFilter)">
      <div class="filter-container">
        <div class="filter-option" :class="selectedOption && 'bold-effect'">{{ selectedOption ? selectedOptionsWritted : allOption }}</div>
        <div class="icon-chevron" />
      </div>
    </div>
    <div class="filter-options-wrapper" :class="activeFilter === typeFilter ? 'lateral-filter-grow' : 'filter-hidden'">
      <div v-if="typeFilter === 'publishDateRange' && minDate !== null && maxDate !== null" class="filter-range-wrapper">
        <div class="filter-range-container">
          <div class="range-title">{{ $t('manual_range') }}</div>
          <vue-slider
            v-if="!equalMinMaxDate"
            v-model="internalValue"
            :value="[minDate.getTime(), maxDate.getTime()]"
            :min="minDate.getTime()"
            :max="maxDate.getTime()"
            :tooltip-formatter="formatterDate"
            :lazy="true"
            :adsorb="true"
            :silent="true"
            :min-range="1"
            :interval="86400000"
            :height="3"
            :marks="objectMarks"
            :style="{ padding: '0'}"
            :process-style="{ backgroundColor: 'black' }"
            :tooltip-style="{ backgroundColor: 'black', borderColor: 'black' }"
            :dot-style="{ backgroundColor: 'black', borderColor: 'black', boxShadow: '0.5px 0.5px 2px 1px rgb(0 0 0 / 32%)' }"
          />
          <div v-else class="unique_wrap">
            <span class="unique_value">{{ $t('unique_date') + formatterDate(minDate.getTime()) }}</span>
          </div>
          <div v-if="isMobile" class="mobile-input-container">
            <input
              v-model="inputinternalValueMin"
              type="date"
              :min="formattedMinDate"
              :max="formattedMaxDate"
            >
            <input
              v-model="inputinternalValueMax"
              type="date"
              :min="formattedMinDate"
              :max="formattedMaxDate"
            >
          </div>
        </div>
      </div>
      <FilterSearch v-if="searchable" @search-pressed="searchFilters" />
      <div class="filter-theme" :class="!selectedOption ? 'selected-value' : ''" @click="selectedOption && lateralFilterChange('', typeFilter, multiselect)">
        <div v-if="!selectedOption" class="icon-check" />
        <div class="filter-theme-option">{{ allOption }}</div>
      </div>
      <div
        v-for="filter in filters"
        :key="typeFilter === 'territory' ? filter : (typeFilter === 'source' ? filter.label[currentLang] : getFilterValue(filter))"
        class="filter-theme"
        :class="isFilterSelected(filter) ? 'selected-value' : ''"
        @click="lateralFilterChange(getFilterValue(filter), typeFilter, multiselect)"
      >
        <div v-if="multiselect" :class="isFilterSelected(filter) ? 'icon-checkbox-checked' : 'icon-checkbox'" />
        <div v-else :class="isFilterSelected(filter) ? 'icon-check' : ''" />
        <div class="filter-theme-option">{{ getFilterLabel(filter) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import FilterSearch from '../search/FilterSearch.vue'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import { findThesaurusNodeByValue, getThesaurusRouteValue } from '@/utils/thesaurusUtils'
import { t } from '../../i18n/index'

var advancedFormat = require('dayjs/plugin/advancedFormat')
dayjs.extend(advancedFormat)

var utc = require('dayjs/plugin/utc')
dayjs.extend(utc)

/**
 * Selector with custom properties
 * @example [none]
 */
export default {
  name: 'CustomSelector',
  components: { FilterSearch, VueSlider },
  props: {
    /**
     * Contains array of options to filter results
     */
    filters: {
      type: Array,
    },
    /**
     * Title of lateral filter
     */
    title: {
      type: String,
    },
    /**
     * Is the type of the current filter
     */
    typeFilter: {
      type: String,
    },
    /**
     * Define if selector has input for search or not
     */
    searchable: {
      type: Boolean,
      default: false,
    },
    /**
     * Defines if selector can admit multiple options
     */
    multiselect: {
      type: Boolean,
      default: false,
    },
    /**
     * this value shows witch select is opened
     */
    activeFilter: {
      type: String,
    },
    /**
     * This function toggle the clicked select
     */
    toggleFilter: {
      type: Function,
    },
    /**
     * Define if this selector is enabled or disabled
     */
    enabled: {
      type: Boolean,
      default: true,
    },
    /**
     * Translation of value all
     */
    allOption: {
      type: String,
    },
    /**
     * Function to run when user types in search input
     */
    searchFilters: {
      type: Function,
    },
    /**
     * Min and max value of time in filters
     */
    searchTimeLimits: {
      type: Object,
    },
  },
  data() {
    return {
      formatterDate: v => `${dayjs(parseInt(v)).format('DD/MM/YYYY')}`,
    }
  },
  computed: {
    objectMarks() {
      if (this.minDate && this.maxDate) {
        let minNumberDate = parseInt(this.minDate.getTime())
        let maxNumberDate = parseInt(this.maxDate.getTime())
        return {
          [minNumberDate]: {
            label: dayjs(minNumberDate).format('DD/MM/YYYY'),
            labelStyle: {
              left: '30px',
              position: 'absolute',
            },
          },
          [maxNumberDate]: {
            label: dayjs(maxNumberDate).format('DD/MM/YYYY'),
            labelStyle: {
              left: '-30px',
              position: 'absolute',
            },
          },
        }
      } else return false
    },
    internalValue: {
      get: function () {
        return [
          this.$route.query && this.$route.query.publishDateRange
            ? parseInt(dayjs(this.$route.query.publishDateRange.split(',')[0]).format('x'))
            : parseInt(dayjs(this.minDate).format('x')),
          this.$route.query && this.$route.query.publishDateRange
            ? parseInt(
                dayjs(this.$route.query.publishDateRange.split(',')[1].substring(0, 10)).format('x')
              )
            : parseInt(dayjs(this.maxDate).format('x')),
        ]
      },
      set: function (newValue) {
        this.rangeChange(newValue[0], newValue[1])
      },
    },
    inputinternalValueMin: {
      get: function () {
        return dayjs(this.internalValue[0]).format('YYYY-MM-DD')
      },
      set: function (newValue) {
        this.rangeChange(parseInt(dayjs(new Date(newValue)).format('x')), this.internalValue[1])
      },
    },
    inputinternalValueMax: {
      get: function () {
        return dayjs(this.internalValue[1]).format('YYYY-MM-DD')
      },
      set: function (newValue) {
        this.rangeChange(this.internalValue[0], parseInt(dayjs(new Date(newValue)).format('x')))
      },
    },
    formattedMinDate() {
      return this.minDate ? dayjs(this.minDate).format('YYYY-MM-DD') : null
    },
    formattedMaxDate() {
      return this.maxDate ? dayjs(this.maxDate).format('YYYY-MM-DD') : null
    },
    equalMinMaxDate() {
      return (this.typeFilter === 'publishDateRange' && this.formattedMinDate === this.formattedMaxDate) ? true : false
    },
    minDate() {
      return this.searchTimeLimits ? new Date(this.searchTimeLimits.min) : null
    },
    maxDate() {
      return this.searchTimeLimits ? new Date(this.searchTimeLimits.max) : null
    },
    selectedOption() {
      return this.$route.query[this.typeFilter] || null
    },
    currentLang() {
      return this.$store.state.i18n.lang
    },
    selectedOptionsWritted() {
      let maxValueTyped = 25
      let transString = ''
      if (this.typeFilter === 'publishDateRange') {
        let range = this.$route.query[this.typeFilter].split(',')
        let min = dayjs(range[0]).format('DD/MM/YYYY')
        let max = dayjs(range[1].substring(0, 10)).format('DD/MM/YYYY')
        transString = min !== max ? min + ' - ' + max : max
      } else if (this.typeFilter === 'source' || this.typeFilter === 'territory') {
        this.$route.query[this.typeFilter]
          .split(',')
          .forEach((el, i) => (transString = transString + (i !== 0 ? ', ' : '') + t(el.replaceAll(' ', '_'))))
      } else {
        transString = this.$route.query[this.typeFilter]
          .split(',')
          .map(el => this.getSelectedThesaurusLabel(el))
          .join(', ')
      }
      if (transString.length <= maxValueTyped) return transString
      else return transString.slice(0, maxValueTyped) + '...'
    },
    lastMonthAvailableRange() {
      let minRangeDate = dayjs(this.maxDate).subtract(1, 'month')
      if (minRangeDate.isBefore(dayjs(this.minDate)))
        return dayjs(this.minDate).utc().format() + ',' + dayjs(this.maxDate).utc().format()
      else return minRangeDate.utc().format() + ',' + dayjs(this.maxDate).utc().format()
    },
    last3MonthsAvailablesRange() {
      let minRangeDate = dayjs(this.maxDate).subtract(3, 'month')
      if (minRangeDate.isBefore(dayjs(this.minDate)))
        return dayjs(this.minDate).utc().format() + ',' + dayjs(this.maxDate).utc().format()
      else return minRangeDate.utc().format() + ',' + dayjs(this.maxDate).utc().format()
    },
    lastYearAvailableRange() {
      let minRangeDate = dayjs(this.maxDate).subtract(1, 'year')
      if (minRangeDate.isBefore(dayjs(this.minDate)))
        return dayjs(this.minDate).utc().format() + ',' + dayjs(this.maxDate).utc().format()
      else return minRangeDate.utc().format() + ',' + dayjs(this.maxDate).utc().format()
    },
  },
  methods: {
    getFilterValue(filter) {
      if (this.typeFilter === 'territory') return filter
      if (this.typeFilter === 'source') return filter.type
      return getThesaurusRouteValue(filter)
    },
    isFilterSelected(filter) {
      let selectedOption = this.selectedOption
      if (!selectedOption) return false
      return selectedOption.split(',').indexOf(this.getFilterValue(filter)) !== -1
    },
    getFilterLabel(filter) {
      if (this.typeFilter === 'territory') return this.$t(filter.replace(/ /g, '_'))
      if (this.typeFilter === 'source') return this.$t(filter.type)
      return filter.label.replace('~', ',')
    },
    getSelectedThesaurusLabel(value) {
      let match = findThesaurusNodeByValue(this.filters, value)
      if (match) return match.label.replace('~', ',')
      let fallbackLabels = this.$route.query[this.typeFilter + 'Label']
      if (fallbackLabels) {
        let values = this.$route.query[this.typeFilter].split(',')
        let labels = fallbackLabels.split(',')
        let labelIndex = values.indexOf(value)
        if (labelIndex !== -1 && labels[labelIndex]) {
          return labels[labelIndex].replace('~', ',')
        }
      }
      return value.replace('~', ',')
    },
    /**
     * Emits an event to know what filter is pressed. (Also reset selector if is multiselect and have all options checked <-- commented to review)
     * @public This is a public method
     * @param {String} filtVal selected lateralfilter label
     * @param {String} filtType The type of the clicked filter
     * @param {Boolean} multiselect if filter has multiselection enabled or not
     * @param {Boolean} open if selector must stay open
     */
    lateralFilterChange(filtVal, filtType, multiselect, open) {
      let filtValue = filtVal
      // if (multiselect) {
      //   let concatVal = ''
      //   this.filters.forEach((element, i) => {
      //     concatVal =
      //       concatVal + (i !== 0 ? ',' : '') + (element.label ? element.label : element.district)
      //   })
      //   let selectedOptionAdded = this.selectedOption
      //     ? this.selectedOption + ',' + filtVal
      //     : filtVal
      //   if (selectedOptionAdded === concatVal) filtValue = ''
      // }
      if (filtType === 'publishDateRange') {
        if (filtVal === t('last_month')) filtValue = this.lastMonthAvailableRange
        else if (filtVal === t('last_3_months')) filtValue = this.last3MonthsAvailablesRange
        else if (filtVal === t('last_year')) filtValue = this.lastYearAvailableRange
      }

      if (filtValue !== this.$route.query.range)
        /** Triggers when the user search a value
         * @event lateral-filter-change
         * @property {String} filtValue selected lateralfilter label
         * @property {String} filtType The type of the clicked filter
         * @property {Boolean} multiselect if filter has multiselection enabled or not
         * @property {Boolean} open if selector must stay open
         */
        this.$emit('lateral-filter-change', filtValue, filtType, multiselect, open)
    },
    rangeChange(minVal, maxVal) {
      let currentRange =
        dayjs(minVal).utc().format() +
        ',' +
        dayjs(maxVal + 86399999)
          .utc()
          .format()
      this.lateralFilterChange(currentRange, 'publishDateRange', false, true)
    },
  },
}
</script>

<style lang="stylus" scoped>
.options-block
  &.option-disabled
    .filter-wrapper
      opacity: 0.5
      // cursor: default !important
      pointer-events: none

  &:not(:last-child)
    margin-bottom: vw(24px)

.options-block-title
  m-font-size(14, 20)
  margin-bottom: vw(8px)
  color: $grey

.filter-wrapper
  &.open-filter
    position: relative

    &:before
      position: absolute
      top: vw(-4px)
      left: vw(-4px)
      width: "calc(100% + %s)" % vw(8px)
      height: "calc(100% + %s)" % vw(8px)
      border-radius: 4px
      background-color: $light-grey
      content: ""

    .icon-chevron
      transform: rotate(180deg)

  .icon-chevron
    m-icon("chevron-down", 24)
    transition: transform 0.25s ease-in-out
    transform-origin: 50% 55%

.filter-container
  position: relative
  display: flex
  justify-content: space-between
  align-items: center
  padding: vw(10px)
  width: 100%
  border: 1px solid $grey
  border-radius: 4px
  background-color: #fff
  cursor: pointer

.filter-option
  m-font-size(16, 26)
  color: $grey
  color: #000

  &.bold-effect
    font-weight: 600

.filter-range-wrapper
  margin-right: vw(-4px)
  margin-bottom: vw(10px)
  margin-left: vw(-4px)
  padding-bottom: vw(10px)
  border-bottom: 1px solid $bcn-grey

  .filter-range-container
    margin-right: vw(10px)
    margin-left: vw(10px)

    .unique_wrap
      display: flex
      text-align: center
      flex-wrap: wrap
      margin-bottom: vw(5px)

      .unique_value
        m-font-size(14, 20)

  .range-title
    m-font-size(14, 20)
    margin-bottom: vw(17px)

  .mobile-input-container
    display: flex
    justify-content: space-between
    width: 100%

  .vue-slider
    margin-right: vw(7px)
    margin-bottom: vw(40px)
    margin-left: vw(7px)

    >>> .vue-slider-mark-label
      m-font-size(14, 20)
      margin-top: vw(17px)

.filter-options-wrapper
  margin-top: vw(8px)
  padding: vw(10px)
  border: 1px solid $grey-grey
  border-radius: 8px
  background-color: #fff

  // box-shadow: 0 4px 10px rgba(105, 105, 115, 0.2)
  .filter-theme
    &:not(:last-child)
      margin-bottom: vw(5px)

.filter-theme
  display: flex
  align-items: center
  padding: vw(6px) vw(8px) vw(6px) vw(32px)
  border-radius: 6px

  &:hover
    // &:not(.selected-value)
    background-color: $corpotative-color-very-light
    cursor: pointer

  &.selected-value
    background-color: $corpotative-color-very-light
    cursor: default

    .filter-theme-option
      color: $corporate_color
      font-weight: 600

  .icon-check
    m-icon("check", 16, $corporate_color)
    margin-right: vw(5px)
    margin-left: vw(-20px)

  .icon-checkbox
    m-icon("check-box-blank", 20)
    margin-top: vw(-1px)
    margin-right: vw(5px)
    margin-left: vw(-24px)

  .icon-checkbox-checked
    m-icon("check-box", 20, $corporate_color)
    margin-right: vw(5px)
    margin-left: vw(-24px)

.filter-theme-option
  m-font-size(14, 18)
  margin-top: 0.1em

.filter-hidden
  display: none

.lateral-filter-grow
  transform-origin: top center
  animation: growDown 0.25s ease-in-out forwards

@keyframes growDown
  0%
    transform: scaleY(0)

  100%
    transform: scaleY(1)
</style>
